module.exports = {
  'align': {
    ''        : require('../~/Template/icons/align-left.svg'),
    'center'  : require('../~/Template/icons/align-center.svg'),
    'right'   : require('../~/Template/icons/align-right.svg'),
    'justify' : require('../~/Template/icons/align-justify.svg')
  },
  'background': require('../~/Template/icons/background.svg'),
  'blockquote': require('../~/Template/icons/blockquote.svg'),
  'bold'      : require('../~/Template/icons/bold.svg'),
  'clean'     : require('../~/Template/icons/clean.svg'),
  'code'      : require('../~/Template/icons/code.svg'),
  'code-block': require('../~/Template/icons/code.svg'),
  'color'     : require('../~/Template/icons/color.svg'),
  'direction' : {
    ''        : require('../~/Template/icons/direction-ltr.svg'),
    'rtl'     : require('../~/Template/icons/direction-rtl.svg')
  },
  'float': {
    'center'  : require('../~/Template/icons/float-center.svg'),
    'full'    : require('../~/Template/icons/float-full.svg'),
    'left'    : require('../~/Template/icons/float-left.svg'),
    'right'   : require('../~/Template/icons/float-right.svg')
  },
  'formula'   : require('../~/Template/icons/formula.svg'),
  'header': {
    '1'       : require('../~/Template/icons/header.svg'),
    '2'       : require('../~/Template/icons/header-2.svg')
  },
  'italic'    : require('../~/Template/icons/italic.svg'),
  'image'     : require('../~/Template/icons/image.svg'),
  'indent': {
    '+1'      : require('../~/Template/icons/indent.svg'),
    '-1'      : require('../~/Template/icons/outdent.svg')
  },
  'link'      : require('../~/Template/icons/link.svg'),
  'list': {
    'ordered' : require('../~/Template/icons/list-ordered.svg'),
    'bullet'  : require('../~/Template/icons/list-bullet.svg'),
    'check'   : require('../~/Template/icons/list-check.svg')
  },
  'script': {
    'sub'     : require('../~/Template/icons/subscript.svg'),
    'super'   : require('../~/Template/icons/superscript.svg'),
  },
  'strike'    : require('../~/Template/icons/strike.svg'),
  'underline' : require('../~/Template/icons/underline.svg'),
  'video'     : require('../~/Template/icons/video.svg')
};



// WEBPACK FOOTER //
// ./ui/icons.js